import CircleIcon from "@mui/icons-material/Circle";
import { keyframes, Tooltip } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";

const blink = keyframes`
  50% { opacity: 0.1; }
`;

export const NewMessageIcon = () => {
    return (
        <Tooltip title={Translations.NewMessage}>
            <CircleIcon
                fontSize="small"
                color="info"
                sx={{
                    marginLeft: ".5rem",
                    animation: `${blink} 1.4s linear infinite`,
                }}
            />
        </Tooltip>
    );
};
